import { render, staticRenderFns } from "./AmeldingForm.vue?vue&type=template&id=195e66d2&scoped=true&"
import script from "./AmeldingForm.vue?vue&type=script&lang=ts&"
export * from "./AmeldingForm.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingForm.vue?vue&type=style&index=0&id=195e66d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e66d2",
  null
  
)

export default component.exports